import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=521782a0&scoped=true&"
import script from "./Quick.vue?vue&type=script&lang=ts&"
export * from "./Quick.vue?vue&type=script&lang=ts&"
import style0 from "./Quick.vue?vue&type=style&index=0&id=521782a0&scoped=true&lang=scss&"
import style1 from "./Quick.vue?vue&type=style&index=1&id=521782a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521782a0",
  null
  
)

export default component.exports